import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import pageReducer from './data/reducer';
import routes from './data/routes';
import pageSaga from './data/sagas';

const reducer = combineReducers({
  app: combineReducers({
    page: pageReducer,
  }),
});

const saga = function* () {
  yield all([pageSaga()]);
};

export { reducer, routes, saga };
